module.exports = __webpack_public_path__ + "img/cert-yyzz.18b16201.svg";